
export default function Legal() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="container mx-auto px-6 lg:px-20 py-4">
          <div className="flex items-center justify-between">
            <img
              src="https://static.readdy.ai/image/482db82fa6135662cb175aa58592a390/0f90afccf080785d3f48ab4b9d5a5a73.png"
              alt="8028 Private Salon"
              className="h-8 w-auto"
            />
            <nav>
              <a
                href="/"
                className="text-gray-600 hover:text-[#EF9786] transition-colors cursor-pointer"
              >
                ホームに戻る
              </a>
            </nav>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="py-12">
        <div className="container mx-auto px-6 lg:px-20 max-w-4xl">
          <h1 className="text-3xl font-bold text-gray-800 mb-8">特定商取引法に基づく表示</h1>
          
          <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
            <table className="w-full">
              <tbody>
                <tr className="border-b border-gray-200">
                  <td className="bg-gray-50 px-6 py-4 font-semibold text-gray-800 w-1/3">販売事業者</td>
                  <td className="px-6 py-4 text-gray-700">8028 GLOBAL株式会社</td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="bg-gray-50 px-6 py-4 font-semibold text-gray-800">運営統括責任者</td>
                  <td className="px-6 py-4 text-gray-700">代表取締役　古市 彰吾</td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="bg-gray-50 px-6 py-4 font-semibold text-gray-800">所在地</td>
                  <td className="px-6 py-4 text-gray-700">東京都港区芝浦　３丁目4-2グランパークハイツ1704</td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="bg-gray-50 px-6 py-4 font-semibold text-gray-800">電話番号</td>
                  <td className="px-6 py-4 text-gray-700">03-5501-3205（受付時間：平日10:00‑17:00）</td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="bg-gray-50 px-6 py-4 font-semibold text-gray-800">メールアドレス</td>
                  <td className="px-6 py-4 text-gray-700">support@8028global.jp</td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="bg-gray-50 px-6 py-4 font-semibold text-gray-800">販売価格</td>
                  <td className="px-6 py-4 text-gray-700">
                    <div className="space-y-2">
                      <div>・初診パッケージ：22,000円（税込）</div>
                      <div>・再診メンテナンスチケット：18,700円（税込）</div>
                      <div className="text-sm text-gray-600 mt-2">
                        ※各サービスページに税込価格を明示<br />
                        ※当社はStripe社の決済システムを利用しています
                      </div>
                    </div>
                  </td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="bg-gray-50 px-6 py-4 font-semibold text-gray-800">商品代金以外の必要料金</td>
                  <td className="px-6 py-4 text-gray-700">インターネット接続に係る通信料、銀行振込の場合の振込手数料</td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="bg-gray-50 px-6 py-4 font-semibold text-gray-800">支払方法</td>
                  <td className="px-6 py-4 text-gray-700">クレジットカード（VISA／Mastercard／JCB／Amex ）</td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="bg-gray-50 px-6 py-4 font-semibold text-gray-800">支払時期</td>
                  <td className="px-6 py-4 text-gray-700">チケット購入（予約確定）時に即時決済</td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="bg-gray-50 px-6 py-4 font-semibold text-gray-800">役務提供時期</td>
                  <td className="px-6 py-4 text-gray-700">予約確定日にサロンにて施術を提供</td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="bg-gray-50 px-6 py-4 font-semibold text-gray-800">キャンセル・変更</td>
                  <td className="px-6 py-4 text-gray-700">
                    <div className="space-y-1">
                      <div>予約の3日前まで：キャンセル料無料</div>
                      <div>2日前：キャンセル料20％</div>
                      <div>前日：キャンセル料50％</div>
                      <div>当日（無断来院含む）：キャンセル料100％</div>
                    </div>
                  </td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="bg-gray-50 px-6 py-4 font-semibold text-gray-800">返金・返品</td>
                  <td className="px-6 py-4 text-gray-700">電子チケットの性質上、購入後の返品はできません。キャンセル料が発生しない場合でも、クレジットカード決済手数料を差し引いた額を返金します。</td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="bg-gray-50 px-6 py-4 font-semibold text-gray-800">販売数量の制限</td>
                  <td className="px-6 py-4 text-gray-700">1回の購入につき最大10チケットまで</td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="bg-gray-50 px-6 py-4 font-semibold text-gray-800">動作環境</td>
                  <td className="px-6 py-4 text-gray-700">
                    推奨ブラウザ：最新のGoogle Chrome／Safari／Edge<br />
                    推奨OS：iOS 15以降、Android 12以降
                  </td>
                </tr>
                <tr>
                  <td className="bg-gray-50 px-6 py-4 font-semibold text-gray-800">特別条件</td>
                  <td className="px-6 py-4 text-gray-700">未成年者は保護者の同意を得たうえでご購入ください。</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="mt-8 text-center">
            <a
              href="/"
              className="inline-flex items-center px-6 py-3 bg-[#EF9786] text-white rounded-full font-semibold hover:bg-[#e8856f] transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-left-line mr-2"></i>
              ホームに戻る
            </a>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-12 mt-16">
        <div className="container mx-auto px-6 lg:px-20">
          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <div>
                <img
                  src="https://static.readdy.ai/image/482db82fa6135662cb175aa58592a390/0f90afccf080785d3f48ab4b9d5a5a73.png"
                  alt="8028 Private Salon"
                  className="h-6 w-auto mb-4"
                />
                <p className="text-gray-400 mb-4">
                  歯の健康を守るプロと患者をつなぐプラットフォーム
                </p>
              </div>
            </div>
            <div>
              <h4 className="font-bold mb-4">会社情報</h4>
              <div className="space-y-2 text-gray-400">
                <p>運営会社：8028Global Inc</p>
                <p>お問い合わせ：support@8028private.com</p>
                <p>
                  Webサイト：
                  <a
                    href="https://8028private.com"
                    className="hover:text-white transition-colors"
                  >
                    https://8028private.com
                  </a>
                </p>
              </div>
            </div>
            <div>
              <h4 className="font-bold mb-4">リンク</h4>
              <div className="space-y-2">
                <div>
                  <a
                    href="/terms"
                    className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                  >
                    利用規約
                  </a>
                </div>
                <div>
                  <a
                    href="/privacy"
                    className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                  >
                    プライバシーポリシー
                  </a>
                </div>
                <div>
                  <a
                    href="/legal"
                    className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                  >
                    特定商取引法に基づく表示
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 8028Global Inc. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
